export enum PrefillPrompts {
	MarketingCampaign = 'marketingCampaign',
	CompetitiveAnalysis = 'competitiveAnalysis',
	SprintPlanning = 'sprintPlanning',
	ExperimentPlan = 'experimentPlan',
	DevOps = 'devOps',
	ProductRoadmap = 'productRoadmap',
	ProductLaunchAnnouncement = 'productLaunchAnnouncement',
}
